import React from "react";
import { formatCommentDate } from "../../types/icomment.functions";
import { CommentsListDateProps } from "./comments-list-date.props";
import { HostContainer } from "./comments-list-date.styles";

export const CommentsListDate = (props: CommentsListDateProps) => (
  <HostContainer>{formatCommentDate(props.comment)}</HostContainer>
);
